import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { trafficData, regionColors, formatTrafficValue } from '../data/trafficData';
import './TrafficChart.css';

const TrafficChart: React.FC = () => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: '2-digit' 
    });
  };

  const formattedData = trafficData.map(item => ({
    ...item,
    date: formatDate(item.time)
  }));

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="traffic-tooltip">
          <p className="tooltip-label">{`Date: ${label}`}</p>
          {payload.map((entry: any, index: number) => (
            <p key={index} style={{ color: entry.color }}>
              {`${entry.dataKey}: ${formatTrafficValue(entry.value)}`}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  const CustomLegend = (props: any) => {
    const { payload } = props;
    return (
      <div className="traffic-legend">
        {payload.map((entry: any, index: number) => (
          <div key={index} className="legend-item">
            <div 
              className="legend-color" 
              style={{ backgroundColor: entry.color }}
            ></div>
            <span className="legend-text">{entry.value}</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="traffic-chart-container">
      <div className="traffic-chart-header">
        <h2>Input traffic by (day & region)</h2>
        <div className="chart-info">
          <span className="chart-period">Last 8 days</span>
        </div>
      </div>
      
      <div className="traffic-chart">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={formattedData}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
            barGap={4}
            barCategoryGap={20}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#2a2a3e" />
            <XAxis 
              dataKey="date" 
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#8b949e', fontSize: 12 }}
            />
            <YAxis 
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#8b949e', fontSize: 12 }}
              tickFormatter={(value) => `${(value / 1024).toFixed(1)} TiB`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend content={<CustomLegend />} />
            <Bar 
              dataKey="eastus2" 
              fill={regionColors.eastus2}
              radius={[2, 2, 0, 0]}
              name="eastus2"
            />
            <Bar 
              dataKey="euwest1" 
              fill={regionColors.euwest1}
              radius={[2, 2, 0, 0]}
              name="eu-west-1"
            />
            <Bar 
              dataKey="northeurope" 
              fill={regionColors.northeurope}
              radius={[2, 2, 0, 0]}
              name="northeurope"
            />
            <Bar 
              dataKey="useast1" 
              fill={regionColors.useast1}
              radius={[2, 2, 0, 0]}
              name="us-east-1"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default TrafficChart;
